// Video quota helpers. Cinematic (video_cinematic_monthly) and standard
// (video_reels_monthly) reels are metered SEPARATELY. Given an entitlements
// usage entry { used, limit, remaining }, describe its state for the quality
// picker + the limits line.
//   limit === null  => unlimited
//   limit === 0     => not on this plan (upsell)
//   limit  >  0     => a monthly quota
export function videoQuotaInfo(usage) {
  if (!usage || typeof usage !== 'object') {
    return { known: false, unlimited: false, inPlan: false, available: false, limit: undefined, remaining: 0, used: 0 };
  }
  const limit = usage.limit;
  const remaining = usage.remaining ?? 0;
  const used = usage.used ?? 0;
  const unlimited = limit === null;
  const inPlan = unlimited || (typeof limit === 'number' && limit > 0);
  const available = unlimited || remaining > 0;
  return { known: true, unlimited, inPlan, available, limit, remaining, used };
}
